module.exports = __webpack_public_path__ + "img/12.5f7e5c07.png";